import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

export const getJoinWorldCupGroupScreenStyles = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.background.primary,
    },
    autoJoinShell: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 32,
      gap: 18,
    },
    autoJoinShellTitle: {
      fontSize: 22,
      fontWeight: '800',
      color: theme.gray[900],
      textAlign: 'center',
      letterSpacing: -0.3,
    },
    autoJoinShellSubtitle: {
      fontSize: 14,
      fontWeight: '500',
      color: theme.gray[600],
      textAlign: 'center',
      lineHeight: 20,
    },
  });
